import React from 'react'
import Notification from 'react-notification'

class Notify extends React.Component {
  state = {
    active: false
  }

  send (message) {
    this.setState({ active: true, message })
  }

  handleDismiss () {
    this.setState({ active: false })
  }

  render () {
    const { message, active } = this.state

    return (
      <Notification
        isActive={active}
        style={{
          bar: {
            bottom: 60,
            backgroundColor: 'rgba(25,25,25,0.8)',
            color: '#eee',
            textAlign: 'center',
            borderRadius: 15,
            boxShadow: 'none',
            WebkitBackdropFilter: 'blur(5px)',
            backdropFilter: 'blur(5px)',
            fontFamily: 'Fira Sans, sans-serif',
            fontSize: 30,
            zIndex: 1000
          },
          action: { display: 'none' }
        }}
        onDismiss={::this.handleDismiss}
        action=""
        message={message || ''} />
    )
  }
}

export default Notify



// WEBPACK FOOTER //
// ./modules/shared/components/notify.js